import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { initRecaptcha, otpRequest } from '../../../../../assets/utility';
import { sendVerificationCodeStart, verifyVerificationCodeStart } from '../../../../ngrx/auth/auth.actions';
import { selectVerifyVerificationCodeIsLoading } from '../../../../ngrx/auth/auth.selectors';
import { BeyOtpComponent } from '../../../shared/components/bey-otp/bey-otp.component';
import { RegistrationLayoutComponent } from '../../../shared/components/registration-layout/registration-layout.component';

/******
 *  This component is used when we enroll the user to Beyonic
 *  It's the second step right after filling up the sign up form
 *  It fires up the login action using an effect
 */
@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.scss'],
  standalone: true,
  imports: [RegistrationLayoutComponent, BeyOtpComponent],
})
export class PhoneVerificationComponent implements OnInit, AfterViewInit, OnDestroy {
  phone: string;
  pin: number;
  currentNav: any;
  verifyVerificationCodeIsLoading$: Observable<boolean>;

  subs$: Subscription = new Subscription();
  done: boolean = false;

  constructor(private store$: Store, public router: Router) {
    this.currentNav = this.router.getCurrentNavigation();
    if (this.currentNav?.extras?.state) {
      this.phone = this.currentNav.extras.state['phone'];
      this.pin = this.currentNav.extras.state['pin'];
      this.store$.dispatch(sendVerificationCodeStart({ payload: { phone: this.phone } }));
    } else {
      router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.verifyVerificationCodeIsLoading$ = this.store$.select(selectVerifyVerificationCodeIsLoading);
  }

  onChange(code: string) {
    if (code.length === 6) {
      initRecaptcha('user_login')
        .then((token: string) => {
          this.store$.dispatch(
            verifyVerificationCodeStart({
              payload: {
                extras: {
                  phone: this.phone,
                  otp: code,
                  pin: this.pin,
                },
                recaptcha: token,
                user: this.currentNav?.extras?.state['loginResponse'] || null,
                route: this.currentNav?.extras?.state['loginResponse'] ? '/' : '/registration/kyc',
              },
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  onClickResend() {
    this.store$.dispatch(sendVerificationCodeStart({ payload: { phone: this.phone } }));
  }

  ngAfterViewInit(): void {
    otpRequest(this.onChange).catch((e) => {
      if (e instanceof DOMException && e.name == 'AbortError') {
        console.warn('WebOTP aborted');
      } else {
        console.error(e);
      }
    });
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
